export const toNumber = (value) => {
    return parseFloat(value.replace(',', '.'));
}